import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>
			<div style={{
				position:"absolute",
				left: 0,
				top: 0,
				width:360,
				height:20,
				backgroundColor:global.blue
			}}/>
			<img src={require('./img/sim-card.png')} style={{
				position:"absolute",
				left: 20,
				top: 80,
				width:30,
				height:30
			}} />
			<div style={{
				position:"absolute",
				left: 20,
				top: 140,
				width:360 - 48,
				height:100,
				// backgroundColor:global.blue,
				// display:"flex",
				// justifyContent:"center",
				// alignItems:"center",
				// cursor:"pointer"
			}}>
				<span style={{
					// color:"white"
					fontWeight:"bold"	
				}}>Insert SIM card</span>
				<br/>
				<br/>
				<span style={{
					// color:"white"
					// fontWeight:"bold"	
					fontSize:14
				}}>The sim card tray is located on the top left edge of your phone</span>
			</div>
			<div style={{
				position:"absolute",
				right: 30,
				top: 320,
				width:90,
				height:40,
				backgroundColor:global.blue,
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				cursor:"pointer"
			}} onClick={global.nextStage}>
				<span style={{
					color:"white"	
				}}>SKIP</span>
			</div>
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Sim.js